
import { formattedNumber } from '../../../utils';

export default (total = 0, value = 0) => formattedNumber(value / total, 'percent', 2);
